import { render, staticRenderFns } from "./ZDMFailureStatusAdmin.vue?vue&type=template&id=da08e324&scoped=true&"
import script from "./ZDMFailureStatusAdmin.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureStatusAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da08e324",
  null
  
)

export default component.exports